import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  CardBody,
  Nav,
  NavItem,
  TabContent,
  TabPane,
  NavLink,
  Label,
  Input,
  Card,
  CardHeader,
  CardTitle,
  Col,
  Row,
  Container,
  Button,
  OffcanvasBody,
} from "reactstrap";
import { AppOffcanvas } from "../../components/Common/AppOverlay";
import { showLoading } from "react-global-loading";

import classnames from "classnames";

import DataTemplate from "./DataTemplateList";
import ReviewTemplate from "./ReviewTemplateList";
import ReviewTemplateStudio from "./ReviewTemplateStudio";
import ReportTemplate from "./ReportTemplateList";
import ReportTemplateCreate from "./ReportTemplateCreate";
import "../Standards/Standards.scss";
import "./TemplateList.scss";

const SysTemplateIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [activeTab, setactiveTab] = useState(1);
  const [active, setActive] = useState("1");
  const [isReviewStudioOpen, setIsReviewStudioOpen] = useState(false);
  const [selectedReviewTemplate, setSelectedReviewTemplate] = useState(null);
  const [reviewTemplateReloadRequest, setReviewTemplateReloadRequest] =
    useState(0);
  const [isReportCreateOpen, setIsReportCreateOpen] = useState(false);
  const [selectedReportTemplateId, setSelectedReportTemplateId] =
    useState(null);
  const [reportTemplateReloadRequest, setReportTemplateReloadRequest] =
    useState(0);
  const reportTemplateChanged = useRef(false);
  const [importDefinitionReloadRequest, setImportDefinitionReloadRequest] = useState(0);

  const openReportTemplate = (id = null) => {
    reportTemplateChanged.current = false;
    setSelectedReportTemplateId(id);
    setIsReportCreateOpen(true);
  };

  const closeReportTemplate = () => {
    if (reportTemplateChanged.current) {
      reportTemplateChanged.current = false;
      setReportTemplateReloadRequest((x) => x + 1);
    }
    setIsReportCreateOpen(false);
    setSelectedReportTemplateId(null);
  };

  const closeReviewStudio = () => {
    setIsReviewStudioOpen(false);
    setSelectedReviewTemplate(null);
  };

  const handleReviewStudioClosed = () => {
    setReviewTemplateReloadRequest((request) => request + 1);
  };

  useEffect(() => {
    if (location.state?.createdReviewTemplate) {
      setSelectedReviewTemplate(location.state.createdReviewTemplate);
      setIsReviewStudioOpen(true);
      navigate(`${location.pathname}${location.search}`, {
        replace: true,
        state: null,
      });
    }
  }, [location.pathname, location.search, location.state, navigate]);

  useEffect(() => {
    if (
      new URLSearchParams(location.search).get("tab") === "import-definitions"
    ) {
      setactiveTab(3);
    }
  }, [location.search]);

  return (
    <React.Fragment>
      <div className="page-content standards-page piers-page">
        <Container fluid>
          <header className="standards-page__header piers-page-header">
            <div>
              <h1 className="piers-page-title">Templates</h1>
              <p>
                {activeTab === 3
                  ? "Define reusable import definitions for Excel, Caseware, CCH and other data sources."
                  : "Manage reusable review and report templates used across inspection workflows."}
              </p>
            </div>
            <div className="template-page-header-actions">
            <Button className="piers-refresh-button"
              type="button"
              color="primary"
              outline
              onClick={() => {
                if (activeTab === 1) setReviewTemplateReloadRequest((value) => value + 1);
                else if (activeTab === 2) setReportTemplateReloadRequest((value) => value + 1);
                else setImportDefinitionReloadRequest((value) => value + 1);
              }}
            >
              <i className="bx bx-refresh" /> Refresh
            </Button>
            <button
              type="button"
              className="standards-page__create"
              data-onboarding-target="reference"
              onClick={() =>
                activeTab === 1
                  ? navigate("/system/templates/review/new")
                  : activeTab === 2
                  ? openReportTemplate()
                  : navigate("/system/templates/import-definitions/new")
              }
            >
              <i className="bx bx-plus" />{" "}
              {activeTab === 3 ? "New Import Definition" : "New Template"}
            </button>
            </div>
          </header>
          <CardBody className="standards-page__body">
            <div id="basic-pills-wizard" className="twitter-bs-wizard">
              <Nav tabs className="standards-page__tabs">
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 1 })}
                    onClick={() => {
                      setactiveTab(1);
                    }}
                  >
                    <span>
                      <i className="bx bx-check-shield" aria-hidden="true" />{" "}
                      Review Template
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 2 })}
                    onClick={() => {
                      setactiveTab(2);
                    }}
                  >
                    <span>
                      <i className="bx bx-file" aria-hidden="true" /> Reports
                      Template
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    href="#"
                    className={classnames({ active: activeTab === 3 })}
                    onClick={() => {
                      setactiveTab(3);
                    }}
                  >
                    <span>
                      <i className="bx bx-transfer-alt" aria-hidden="true" />{" "}
                      Import Definitions
                    </span>
                  </NavLink>
                </NavItem>
              </Nav>

              <TabContent
                className="twitter-bs-wizard-tab-content standards-page__tabs-content"
                style={{ paddingTop: "10px" }}
                activeTab={activeTab}
              >
                <TabPane tabId={1}>
                  <ReviewTemplate
                    refreshRequest={reviewTemplateReloadRequest}
                  />
                </TabPane>
                <TabPane tabId={2}>
                  <ReportTemplate
                    refreshRequest={reportTemplateReloadRequest}
                    onEdit={openReportTemplate}
                  />
                </TabPane>
                <TabPane tabId={3}>
                  <DataTemplate refreshRequest={importDefinitionReloadRequest} />
                </TabPane>
              </TabContent>
            </div>
          </CardBody>
          <AppOffcanvas
            backdrop="static"
            className="review-template-studio-drawer"
            direction="end"
            isOpen={isReviewStudioOpen}
            onClosed={handleReviewStudioClosed}
            toggle={closeReviewStudio}
          >
            <OffcanvasBody>
              <ReviewTemplateStudio
                template={selectedReviewTemplate}
                closeAction={closeReviewStudio}
              />
            </OffcanvasBody>
          </AppOffcanvas>
          <AppOffcanvas
            backdrop="static"
            className="report-template-drawer"
            direction="end"
            isOpen={isReportCreateOpen}
            toggle={closeReportTemplate}
          >
            <div className="report-template-drawer__body">
              <ReportTemplateCreate
                templateId={selectedReportTemplateId}
                closeAction={closeReportTemplate}
                onSaved={() => {
                  reportTemplateChanged.current = true;
                }}
              />
            </div>
          </AppOffcanvas>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SysTemplateIndex;
